import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

// 5 sequential Smart Site mockups across the customer journey (auto rotates every 3s)
const SLIDES = [
  { src: "/framework_carousel/verdant_01_hero.png",     label: "Verdant Estate Landscaping",  niche: "01 · Hero" },
  { src: "/framework_carousel/verdant_02_enquiry.png",  label: "Verdant Estate Landscaping",  niche: "02 · Enquiry" },
  { src: "/framework_carousel/verdant_03_aichat.png",   label: "Verdant Estate Landscaping",  niche: "03 · AI Front Desk" },
  { src: "/framework_carousel/verdant_04_booked.png",   label: "Verdant Estate Landscaping",  niche: "04 · Booked" },
  { src: "/framework_carousel/verdant_05_social.png",   label: "Verdant Estate Landscaping",  niche: "05 · Content Autopilot" },
];

export default function FrameworkCarousel() {
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    const t = setInterval(() => {
      setIdx((p) => (p + 1) % SLIDES.length);
    }, 3000);
    return () => clearInterval(t);
  }, []);

  const slide = SLIDES[idx];

  return (
    <div className="relative w-full" data-testid="framework-carousel-wrapper">
      <div className="relative aspect-[16/11] w-full rounded-3xl overflow-hidden bg-slate-50 shadow-[0_30px_80px_-30px_rgba(15,23,42,0.25)] ring-1 ring-slate-200/70">
        <AnimatePresence mode="sync">
          <motion.img
            key={slide.src}
            src={slide.src}
            alt={`${slide.label} Smart Site mockup`}
            className="absolute inset-0 w-full h-full object-contain"
            initial={{ opacity: 0, scale: 1.02 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.99 }}
            transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
            data-testid={`framework-slide-${idx}`}
            loading="eager"
          />
        </AnimatePresence>

        {/* Floating niche tag */}
        <AnimatePresence mode="wait">
          <motion.div
            key={`tag-${slide.niche}-${idx}`}
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -8 }}
            transition={{ duration: 0.35 }}
            className="absolute top-4 left-4 inline-flex items-center gap-2 bg-white/95 backdrop-blur-sm border border-slate-200 rounded-full px-3.5 py-1.5 shadow-sm"
          >
            <span className="w-1.5 h-1.5 rounded-full bg-blue-500 animate-pulse" />
            <span className="text-[11px] font-bold tracking-[0.15em] uppercase text-slate-900">{slide.niche}</span>
          </motion.div>
        </AnimatePresence>
      </div>

      {/* Slide indicators */}
      <div className="flex items-center justify-center gap-1.5 mt-5" data-testid="framework-carousel-dots">
        {SLIDES.map((_, i) => (
          <button
            key={i}
            type="button"
            onClick={() => setIdx(i)}
            aria-label={`Show slide ${i + 1}`}
            data-testid={`framework-dot-${i}`}
            className={`h-1.5 rounded-full transition-all duration-500 ${i === idx ? "w-7 bg-blue-600" : "w-1.5 bg-slate-300 hover:bg-slate-400"}`}
          />
        ))}
      </div>
    </div>
  );
}
